import styled from 'styled-components'

export const StyledPaginationContainer = styled.div`
    display: flex;

    .pagination-item {
    padding: 0 12px;
    height: 32px;
    text-align: center;
    margin: auto 4px;
    color: rgba(84, 95, 125, 0.6);
    display: flex;
    align-items: center;
    letter-spacing: 0.01071em;
    border-radius: 16px;
    font-size: 1.6rem;
    font-weight: 500;
    min-width: 32px;

    @media(max-width: 356px) {
        margin: 0;
    }

    &.dots:hover {
      background-color: transparent;
      cursor: default;
    }
    &:hover {
      /* background-color: rgba(0, 0, 0, 0.04); */
      cursor: pointer;
    }

    &.selected {
      background-color: rgba(0, 0, 0, 0.08);
      color: #545F7D;
    }

    .arrow-container {
        display: flex;
        align-items: center;
        height: 100%;
        width: 24px;
        justify-content: center;
        background: rgba(33, 63, 125, 0.1);
        border-radius: 4px;
        color: #213F7D;
    }

    &.disabled {
      pointer-events: none;

      .arrow-container {
        color: rgba(33, 63, 125, 0.4);
      }

      &:hover {
        background-color: transparent;
        cursor: default;
      }
    }
  }
`